import { ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { CommanderThunkDispatch, WithDataTestId } from '@mews-commander/types';
import { OptimusPlainLink } from '@mews-commander/ui';
import { ModalCallbacks, openModal } from '../../../../modules/app/actions/common';

interface ModalLinkProps<Data> extends Omit<ModalCallbacks<Data>, 'onDataReceived' | 'onClose'>, WithDataTestId {
    url: string;
    children: ReactNode;
}

export const ModalLink = <Data,>({ children, url, ...other }: ModalLinkProps<Data>) => {
    const dispatch: CommanderThunkDispatch = useDispatch();

    return (
        <OptimusPlainLink
            href={url}
            onClick={() => {
                dispatch(openModal(url));
            }}
            inherit
            {...other}
        >
            {children}
        </OptimusPlainLink>
    );
};
